import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { AddressTypeService } from '../../../services';

const { Option } = Select;

class AddressTypeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.getAddressTypes();
  }

  getAddressTypes() {
    AddressTypeService.getAddressTypes().then((result) => {
      this.setState({
        data: result.data,
      });
    });
  }

  render() {
    return (
      <Select
        className={this.props.className}
        value={this.props.value}
        onChange={this.props.onChange}        
      >
        {
          this.state.data.map((opt) => (
            <Option
              key={opt.Id}
              value={opt.Id}
            >
              {opt.Name}
            </Option>
          ))
        }
      </Select>
    );
  }
}

AddressTypeSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  className: PropTypes.string,
};

AddressTypeSelect.defaultProps = {
  value: null,
  className: ""
};

export { AddressTypeSelect as default };
